import styled from 'styled-components';
import whatsappIcon from '../../assets/img/whatsapp.svg';
import { useStoreInfo } from '../../store/useStoreInfo';

const WhatsAppLink = styled.a`
  position: fixed;
  bottom: 40px;
  left: 5%;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: oklch(0.7225 0.1924 149.67);
  color: oklch(0.2077 0.0398 265.75);
  transition: all 0.3s;
  box-shadow: oklch(0.7225 0.1924 149.67 / 0.2) 1px 11px 20px 0px;
  text-decoration: none;

  &:hover {
    box-shadow: oklch(0.7225 0.1924 149.67 / 0.4) 1px 15px 25px 0px;
  }

  @media (max-width: 768px) {
    width: 55px;
    height: 55px;
    bottom: 30px;
  }
`;

const WhatsAppIcon = styled.img`
  width: 24px;
  height: 24px;
`;

/** رقم واتساب افتراضي عند عدم وجود قيمة من المتجر */
const DEFAULT_WHATSAPP = '966595650656';

function normalizeWhatsAppPhone(value: string | null | undefined): string {
  if (!value || typeof value !== 'string') return DEFAULT_WHATSAPP;
  const digits = value.replace(/\D/g, '');
  if (!digits.length) return DEFAULT_WHATSAPP;
  return digits.startsWith('0') ? '966' + digits.slice(1) : digits;
}

const WhatsAppButton = () => {
  const { data: storeData } = useStoreInfo();
  const phone = normalizeWhatsAppPhone(storeData?.whatsapp ?? undefined);
  const href = `https://wa.me/${phone}`;

  return (
    <WhatsAppLink
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="تواصل معنا على واتساب"
    >
      <WhatsAppIcon src={whatsappIcon} alt="واتساب" />
    </WhatsAppLink>
  );
};

export default WhatsAppButton;
